import { Button, Input, Option, Select } from '@material-tailwind/react'
import React from 'react'

const PropertyForm = ({addImage,propertyImages,setPropertyImages,imageUrl,setImageUrl,propertyName,setPropertyName,propertyStartingPrice,setPropertyStartingPrice,propertyType,setPropertyType,propertyLocation,setPropertyLocation,propertyMap,setPropertyMap,youtubeVideo,setYoutubeVideo,propertyDescription,setPropertyDescription,handleAddProperty,singleRoom,setSingleRoom,rooms,setRooms,roomImageUrl,addRoomImage,addCoverImage,propertyCoverImages,propertyDescriptionTitle,setPropertyDescriptionTitle}) => {
  return (
    <div className='ml-[20rem]   ' >
        <div className='py-6' >
        <h3 className='font-[NeueBold] text-[2rem]' >Add New Property</h3>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Property Details</h3>
        <div className=' flex items-center justify-start flex-wrap gap-4 ' >
            <div className='w-[350px]' >
                <Input value={propertyName} onChange={(e)=>setPropertyName(e.target.value)} label='Property Name' />
            </div>
            <div className='w-[350px]' >
                <Input value={propertyStartingPrice} onChange={(e)=>setPropertyStartingPrice(e.target.value)} label='Property Starting Price' />
            </div>
            <div className='w-[350px]' >
                <Input value={propertyLocation} onChange={(e)=>setPropertyLocation(e.target.value)} label='Property Location' />
            </div>
            <div className='w-[350px]' >
                <Input value={propertyDescriptionTitle} onChange={(e)=>setPropertyDescriptionTitle(e.target.value)} label='Property Description Title' />
            </div>
            <div className='w-[350px]' >
                <Input value={propertyDescription} onChange={(e)=>setPropertyDescription(e.target.value)} label='Property Description' />
            </div>
            
            <div className='w-[350px]' >
                <Input value={propertyMap} onChange={(e)=>setPropertyMap(e.target.value)} label='Property Map' />
            </div>
            <div className='w-[350px]' >
                <Input value={youtubeVideo} onChange={(e)=>setYoutubeVideo(e.target.value)} label='Youtube Video' />
            </div>
            <div className='w-[350px]' >
                <Select value={propertyType} onChange={(e)=>setPropertyType(e)} label='Property Status'>
                    <Option value='available' >Available</Option>
                    <Option value='sold out' >Sold Out</Option>
                </Select>
            </div>
        </div>
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Property Images</h3>
        <div>
        <div>
                     <form  onSubmit={addImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                    {
                        propertyImages?.map((image)=>(
                            <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={image} />
                            </div>
                        ))
                    }
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Property Cover Images</h3>
        <div>
        <div>
                     <form  onSubmit={addCoverImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                    {
                        propertyCoverImages?.map((image)=>(
                            <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={image} />
                            </div>
                        ))
                    }
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Rooms</h3>
        <div>
        <div className='flex gap-6 items-start justify-start' > 
        <div>
            <Input onChange={(e)=>setSingleRoom({...singleRoom,roomTitle:e.target.value})} value={singleRoom.roomTitle} label='Room Title' />
            </div>
            <div>
            <Input onChange={(e)=>setSingleRoom({...singleRoom,roomContent:e.target.value})} value={singleRoom.roomContent} label='Room Content' />
            </div>
            <div className='flex items-center justify-start ' >
                     <form  onSubmit={addRoomImage} className='form flex items-center justify-center flex-col my-0 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      <div>
     {roomImageUrl.length !== 0 && <img src={roomImageUrl} className='w-[80px] h-[80px]' />}
      </div>
      
                </div>
        </div>
       
              
        </div>
        <div className='flex items-center justify-center my-6' >
        <Button onClick={()=>setRooms([...rooms,singleRoom])} className='' >+  Add Room</Button>
       </div>
        <div className='' >
            <div className='grid my-6 bg-gray-200 py-3 px-3 font-[NeueMedium] grid-cols-3   grid-flow-col' >
                 <p>Room Image</p>
                 <p>Room Title</p>   
                 <p>Room Content</p>      
            </div>
            {
                rooms?.map((room)=>(
                    <div className='grid my-6 bg-gray-200 py-3 px-3 font-[NeueMedium] grid-cols-3   grid-flow-col' >
                 <img src={room.roomImage} className='w-[80px] h-[80px]' />
                 <p>{room.roomTitle}</p>   
                 <p>{room.roomContent}</p>      
            </div>
                ))
            }
          
        </div>
      
        </div>
        <div className='my-3 flex items-center justify-end mr-3' >
            <Button onClick={handleAddProperty} >Publish</Button>
        </div>
        </div>
    </div>
  )
}

export default PropertyForm